export const APP_NAME = 'Vitalia Care'
export const PERSIST_STORE_NAME = 'vitalia-care'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const APP_VERSION = '2.7.0'
